<template>
  <v-layout>
    <v-app-bar :elevation="0" absolute height="56" class="position-fixed">
      <v-app-bar-nav-icon @click="drawer = !drawer" class="mr-n4"></v-app-bar-nav-icon>
      <div class="d-flex justify-space-between v-toolbar__content__header">
        <div
          :class="['d-flex align-center globo', route.fullPath === '/' ? 'none' : 'cursor-pointer']"
          @click="navigateTo('/')"
        >
          <img src="/globo_white.svg" />
          <span class="font-20 mx-3">|</span>
          <b class="font-18">Globo Entregas</b>
        </div>

        <v-menu>
          <template #activator="{ props }">
            <v-btn v-bind="props" variant="outlined">
              <v-icon v-if="!currentUser.name" icon="mdi-account" />
              <div v-else-if="isMobile()">
                {{ currentUser.name?.split(' ')?.[0]?.[0]
                }}{{ currentUser.name?.split(' ')?.[1]?.[0] }}
              </div>
              <div v-else>
                {{ currentUser.name }}
              </div>
            </v-btn>
          </template>
          <v-card class="pa-2">
            <v-card-text class="text-dark-grey">{{ currentUser.email }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="error" variant="text" append-icon="mdi-logout" @click="logout"
                >Sair</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
      <div v-if="envName !== 'prd'" :class="['env', envName]">{{ envName }}</div>
    </v-app-bar>

    <v-main><slot /></v-main>

    <v-navigation-drawer v-model="drawer" temporary width="150">
      <v-list density="compact" nav>
        <v-list-item class="text-center" to="/">
          <v-icon icon="mdi-calendar-edit" />
          <v-list-item-title><span class="font-16">Agendamentos</span></v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="text-center" to="/archived/scheduling">
          <v-icon icon="mdi-calendar-lock" />
          <v-list-item-title
            ><span class="font-16">Agendamentos<br />arquivados</span></v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-layout>
</template>

<script setup lang="ts">
useState('msToken', () => {});
useState('filterScheduling', () => {
  return ast.filterSchedulingDefault;
});
useState('listPayload', () => {
  return ast.listPayloadDefault;
});

// vars
const cfgPublic = useRuntimeConfig().public;
const envName = cfgPublic.env;
const route = useRoute();
const nuxtApp = useNuxtApp();

const currentUser = computed(() => {
  return useState('currentUser').value as GuestInterface;
});

const drawer = ref(false);

function logout() {
  delete nuxtApp.payload.state['currentUser'];
  sessionStorage.removeItem('expiresIn');
  sessionStorage.removeItem('token');
  navigateTo('/login');
}
</script>

<style lang="scss" scoped>
.env {
  color: var(--grey);
  letter-spacing: -1px;
  position: fixed;
  right: 0;
  top: 0;

  &.localprd {
    background-color: #fad;
  }

  &.localhml {
    background-color: #d99977;
  }

  &.localdev {
    background-color: #ecd9dd;
  }

  &.dev {
    background-color: #ede99d;
  }
}

.v-toolbar {
  background: linear-gradient(135deg, #0079fd 0, #8800f8 100%) !important;
  color: white !important;
}

.v-layout {
  min-height: 100vh;
}
</style>
